import { objectToParam } from "../../libs/utils";
import axios from "../api";

export async function getSafetyQuestions(eventId, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(
    `events/${eventId}/safety-questions?${parameters}`
  );
  return data;
}

export async function getSafetyQuestion(eventId, id) {
  const { data } = await axios.get(`events/${eventId}/safety-questions/${id}`);
  return data;
}

export async function createSafetyQuestion(eventId, values) {
  const { data } = await axios.post(
    `events/${eventId}/safety-questions`,
    values
  );
  return data;
}

export async function updateSafetyQuestion(eventId, id, values) {
  const { data } = await axios.patch(
    `events/${eventId}/safety-questions/${id}`,
    values
  );
  return data;
}

export async function deleteSafetyQuestion(eventId, id) {
  const { data } = await axios.delete(
    `events/${eventId}/safety-questions/${id}`
  );
  return data;
}

export async function getSafetyQuestionAnswersForApproval(eventId, filterApproved)
{
  let filter = '';

  if (filterApproved && filterApproved !== '') {
    if(filterApproved === 'unhandled') {
      filter = `&filter[unhandled]=1`;
    } else if(filterApproved === 'approved') {
      filter = `&filter[approved]=1`;
    } else if(filterApproved === 'rejected') {
      filter = `&filter[rejected]=1`;
    }
  }

  const { data } = await axios.get(`events/${eventId}/safety-question-answers?include=safetyQuestion,registration,registration.company${filter}`);
  return data;
}

export async function approveSafetyQuestionAnswer(eventId, answerId)
{
  const { data } = await axios.post(`events/${eventId}/safety-question-answers/${answerId}/approve`);
  return data;
}

export async function rejectSafetyQuestionAnswer(eventId, answerId)
{
  const { data } = await axios.post(`events/${eventId}/safety-question-answers/${answerId}/reject`);
  return data;
}